export default {
  "content": "<path d=\"M30 1.13H2c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2v20.5c0 .82.68 1.5 1.5 1.5h25c.82 0 1.5-.68 1.5-1.5V9.13c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2zm-2 28H4v-20h24v20zm2-22H2v-4h28v4z\"/><path fill-rule=\"evenodd\" d=\"M20.7 18.85a.97.97 0 01-1.4 0l-1.74-1.72-.58-.58v7.58c0 .56-.46 1-1 1s-1-.44-1-1v-7.58l-.58.58-1.72 1.7a.97.97 0 01-1.4 0 .967.967 0 010-1.4l.22-.22 2.06-2.08 1.66-1.66c.18-.2.46-.34.76-.34.26 0 .52.1.7.3l4.02 4.02c.4.38.4 1.02 0 1.4z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "32",
    "height": "33",
    "fill": "currentColor",
    "viewBox": "0 0 32 33"
  }
};